import { useDispatch, useSelector } from 'react-redux'

import { caseQuickUpdate } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import { caseActions } from '../../../../store/case'

import classes from './GroupItemSearch.module.css'

const GroupItemSearchOption = ({item, data, fieldsData, action, label, folder}) => {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const selectOptionHandler = async () => {
        let reqBody;
        if (folder == 'attorneys') {
            reqBody = {
                type: `case_attorney`,
                type_id: data.id,
                fields: {
                    [fieldsData.fieldId] : item.id,
                }
            }
        } else if (folder == 'liabilities') {
            reqBody = {
                type: `case_liability`,
                type_id: data.id,
                fields: {
                    [fieldsData.fieldId] : item.id,
                }
            }
        } else if (folder == 'mp_pip_um') {
            reqBody = {
                type: `case_mp_pip_um`,
                type_id: data.id,
                fields: {
                    [fieldsData.fieldId] : item.id,
                }
            }

            if (fieldsData.fieldId == 'mp_adjuster_id' && !data.um_adjuster_id) { //create a new adjuster for mp_adjuster_id but there is no  um_adjuster_id so added there also
                reqBody.fields.um_adjuster_id = item.id
            }

            if (fieldsData.fieldId == 'um_adjuster_id' && !data.mp_adjuster_id) { //create a new adjuster for um_adjuster_id but there is no  mp_adjuster_id so added there also
                reqBody.fields.mp_adjuster_id = item.id
            }

        } else if (folder == 'major_meds') {
            reqBody = {
                type: `case_major_med`,
                type_id: data.id,
                fields: {
                    [fieldsData.fieldId] : item.id,
                }
            }
        } else if (folder == 'worker_comps') {
            reqBody = {
                type: `case_worker_comp`,
                type_id: data.id,
                fields: {
                    [fieldsData.fieldId] : item.id,
                }
            }
        } else if (folder == 'worker_comp') {
            reqBody = {
                type: `case_worker_comp`,
                fields: {
                    [fieldsData.fieldId] : item.id,
                }
            }
        }
        

        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            
            dispatch(notificationActions.setError(update))

        } else {
            // caseQuickUpdate returns { data, caseData, staleResponse }; entity is under .data
            const entity = update?.data ?? update
            if (entity && !update?.staleResponse && !update?.aborted) {
                
                let dispatchBody = {
                    folder: folder,
                    item: {
                        itemId: data.id,
                        fields: [
                            {
                                field: fieldsData.fieldId,
                                value: entity.id
                            },
                            {
                                field: fieldsData.fieldobj,
                                value: entity
                            }
                        ]              
                    },
                }

                if (fieldsData.fieldId == 'mp_adjuster_id' && !data.um_adjuster_id) { //create a new adjuster for mp_adjuster_id but there is no  um_adjuster_id so added there also
                    dispatchBody.item.fields.push({
                        field: 'um_adjuster_id',   //'adjuster_id',
                        value: entity.id
                    },
                    {
                        field: 'um_adjuster', //'adjuster',
                        value: entity
                    })
                }
    
                if (fieldsData.fieldId == 'um_adjuster_id' && !data.mp_adjuster_id) { //create a new adjuster for um_adjuster_id but there is no  mp_adjuster_id so added there also
                    dispatchBody.item.fields.push({
                        field: 'mp_adjuster_id',   //'adjuster_id',
                        value: entity.id
                    },
                    {
                        field: 'mp_adjuster', //'adjuster',
                        value: entity
                    })
                }
                setTimeout(() => {
                    dispatch(caseActions.modifyActiveCaseMultiple(dispatchBody))
                }, 0)
            }
        } 

        action()
    }

    let name = item.name
    if (label == 'location') {
        if (item.contact_information) {
            if (item.contact_information?.address_1 || item.contact_information?.city || item.contact_information?.state || item.contact_information?.zip) {
                name = item.contact_information?.address_1 + ' ' + item.contact_information?.city + ' ' + item.contact_information?.state + ' ' + item.contact_information?.zip
            } else {
                name = item.name + (' (No address on file)')
            }
        }
    }

    return <div className={classes.searched_option}>
        <button onClick={selectOptionHandler}>{name}</button>
    </div>
}

export default GroupItemSearchOption